<template>
  <Transition
    enter-active-class="transition-transform duration-300 ease-out"
    enter-from-class="translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transition-transform duration-200 ease-in"
    leave-from-class="translate-y-0"
    leave-to-class="translate-y-full"
  >
    <div
      v-if="visible"
      class="fixed bottom-0 left-0 right-0 z-50 bg-md-surface border-t border-md-outline-variant p-4 shadow-lg"
    >
      <p class="text-sm text-md-on-surface mb-3">
        Мы используем технические cookies для сохранения настроек интерфейса. Продолжая использование, вы соглашаетесь с
        <router-link to="/cookies" class="text-md-primary hover:underline">политикой cookies</router-link>
        и
        <router-link to="/privacy" class="text-md-primary hover:underline">политикой обработки персональных данных</router-link>.
      </p>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="md-ripple flex-1 rounded-md bg-md-primary-container px-3 py-2 text-sm font-medium text-md-on-primary-container hover:opacity-90"
          @click="accept"
        >
          Согласен
        </button>
        <button
          type="button"
          class="md-ripple rounded-md px-3 py-2 text-sm font-medium text-md-on-surface-variant hover:bg-md-surface-hover"
          @click="decline"
        >
          Нет
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const STORAGE_KEY = 'qa-kit-cookie-consent';

const saved = localStorage.getItem(STORAGE_KEY);
const visible = ref(saved === null);

const accept = () => {
  localStorage.setItem(STORAGE_KEY, 'accepted');
  visible.value = false;
};

const decline = () => {
  localStorage.setItem(STORAGE_KEY, 'declined');
  visible.value = false;
};
</script>
